import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Plus } from "lucide-react";
import React from "react";


export const EmployeeDetails = ({ clientDetails,handleEmployeeUpload }) => {
    return (
        <>
       <div className="flex justify-end mb-4">
        <Button
                  data-testid="add-vehicle-btn"
                  className="bg-[#FF6B35] hover:bg-[#E55A28] text-white rounded-full px-6 py-6"
                    onClick={() => {
                        const fileInput = document.createElement("input");
                        fileInput.type = "file";
                        fileInput.accept = ".csv";
                        fileInput.onchange = (e) => {
                            const file = e.target.files[0];
                            if (file) {
                                handleEmployeeUpload(file);
                            }
                        };
                        fileInput.click();
                    }}
                >
                  <Plus className="mr-2" size={20} />
                   Upload Employees Data
                </Button>
       </div> 
        <div className="mt-8">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Employee Name</TableHead>
                <TableHead>Email</TableHead>
                <TableHead>Vehicle Count</TableHead>
                <TableHead>Booking Count</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {clientDetails?.users?.map((emp) => (
                <TableRow key={emp.email}>
                  <TableCell>{emp.name}</TableCell>
                  <TableCell>{emp.email}</TableCell>
                  <TableCell>{emp.vehicle_count ?? "—"}</TableCell>
                  <TableCell>{emp.booking_count ?? "—"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        </>
    );
}
            